/**
 * Web-SSH: mevcut altyapı ttyd + nginx /term/ kapısıdır (xterm.js'i ttyd
 * kendisi sunar; oturum cookie'si kapıda doğrulanır). Panel terminali,
 * aynı sayfada koyu panel içinde bu adresi iframe olarak gömer.
 */
class SshService {
  /** Cihaz için gömülü terminal adresi. */
  termUrl(serial: string): string {
    return `/term/?arg=${encodeURIComponent(serial)}`;
  }
}

export const ssh = new SshService();
